<template>
  <b-card
    v-if="tableData"
    no-body
    class="card-company-table"
  >
    <b-table
      :items="tableData"
      responsive
      :fields="fields"
      class="mb-0"
    >
      <!-- company -->
      <template #cell(company)="data">
        <div class="d-flex align-items-center">
          <b-avatar
            rounded
            size="48"
            variant="transparent"
            class="mr-1"
          >
            <b-img
              :src="data.item.partnerLogo"
              alt="avatar img"
              style="object-fit: contain; width: 48px"
          /></b-avatar>
          <div>
            <div class="font-weight-bolder">
              {{ data.item.partnerName }}
            </div>
            <div class="font-small-2 text-muted">
              {{ data.item.partnerEmails.join(', ') }}
            </div>
          </div>
        </div>
      </template>

      <!-- totalUser -->
      <template #cell(totalUser)="data">
        <div class="d-flex align-items-center">
          <span class="text-black font-weight-bolder">{{
            data.item.totalUsers
          }}</span>
        </div>
      </template>

      <!-- views -->
      <template #cell(totalBanner)="data">
        <div class="d-flex flex-column">
          <span class="font-weight-bolder mb-25">{{
            data.item.totalBanners
          }}</span>
        </div>
      </template>

      <!-- revenue -->
      <!-- <template #cell(totalRevenue)="data">
        {{ data.item.totalRevenue }}
      </template> -->

      <!-- sales -->
      <template #cell(totalPosts)="data">
        <div class="d-flex align-items-center">
          <span class="font-weight-bolder mr-1">{{
            data.item.totalPosts
          }}</span>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BCard, BTable, BAvatar, BImg } from 'bootstrap-vue';

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BImg,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      fields: [
        { key: 'company', label: 'PARTNER' },
        { key: 'totalUser', label: 'USER' },
        { key: 'totalBanner', label: 'BANNER' },
        { key: 'totalPosts', label: 'POST' },
        // { key: 'totalRevenue', label: 'REVENUE' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
</style>
